"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserHeightCalibrationStatus = void 0;
var UserHeightCalibrationStatus;
(function (UserHeightCalibrationStatus) {
    UserHeightCalibrationStatus[UserHeightCalibrationStatus["NONE"] = 0] = "NONE";
    UserHeightCalibrationStatus[UserHeightCalibrationStatus["RECORDING_FLOOR"] = 1] = "RECORDING_FLOOR";
    UserHeightCalibrationStatus[UserHeightCalibrationStatus["WAITING_FOR_CONTROLLER_PITCH"] = 2] = "WAITING_FOR_CONTROLLER_PITCH";
    UserHeightCalibrationStatus[UserHeightCalibrationStatus["WAITING_FOR_RISE"] = 3] = "WAITING_FOR_RISE";
    UserHeightCalibrationStatus[UserHeightCalibrationStatus["WAITING_FOR_FW_LOOK"] = 4] = "WAITING_FOR_FW_LOOK";
    UserHeightCalibrationStatus[UserHeightCalibrationStatus["RECORDING_HEIGHT"] = 5] = "RECORDING_HEIGHT";
    UserHeightCalibrationStatus[UserHeightCalibrationStatus["DONE"] = 6] = "DONE";
    UserHeightCalibrationStatus[UserHeightCalibrationStatus["ERROR_TOO_HIGH"] = 7] = "ERROR_TOO_HIGH";
    UserHeightCalibrationStatus[UserHeightCalibrationStatus["ERROR_TOO_SMALL"] = 8] = "ERROR_TOO_SMALL";
    UserHeightCalibrationStatus[UserHeightCalibrationStatus["ERROR_TIMEOUT"] = 9] = "ERROR_TIMEOUT";
})(UserHeightCalibrationStatus = exports.UserHeightCalibrationStatus || (exports.UserHeightCalibrationStatus = {}));
